import { SheetHeader } from './';

export class Preset {
    presetId: string;
    name: string;
    isActive: boolean=true;
    sheetHeader: SheetHeader[] = [];
}